import { Card, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../../Components/Loader';
import Message from '../../Components/Message';
import { useGetAdminProductCategoriesQuery } from '../../slices/productsApiSlice';
import BackButton from "../../Components/BackButton";

export default function AdminProductsHub() {
  const navigate = useNavigate();
  // use curated categories; empty ones will appear with count=0
  const { data: cats = [], isLoading, error } = useGetAdminProductCategoriesQuery();

  return (
    <>
    <BackButton />
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h1 className="mb-0">Manage Products</h1>
        <div className="d-flex gap-2">
          <Button as={Link} to="/admin/barcode-lookup" variant="outline-primary" size="sm">
            Barcode scanner
          </Button>
          <Button as={Link} to="/admin/part-categories" variant="outline-secondary" size="sm">
            Manage categories
          </Button>
        </div>
      </div>
      <p className="text-muted">Choose a category to list or add products.</p>
      {isLoading && <Loader />}
      {error && <Message variant="danger">{error?.data?.message || error.error}</Message>}
      <Row className="g-3">
        {cats.map((c) => (
          <Col key={c.name} sm={12} md={6} lg={4} xl={3}>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className="mb-1">{c.name || 'Uncategorized'}</Card.Title>
                  <div className="text-muted small mb-2">
                  {c.count || 0} {c.count === 1 ? 'item' : 'items'}
                </div>
                </div>
                <div className="d-flex gap-2 mt-3">
                  <Button
                    size="sm"
                    onClick={() =>
                      navigate(`/admin/productlist?category=${encodeURIComponent(c.name || '')}`)
                    }
                  >
                    Manage
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() =>
                      navigate(`/admin/productlist?category=${encodeURIComponent(c.name || '')}&create=1`)
                    }
                  >
                    + Add product
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
}
